import querystring from './querystring';
import hashParams from './hash-params';

const debugTrigger = 'advertdebug';

if (
	querystring.get(debugTrigger) !== undefined ||
	hashParams.get(debugTrigger) !== undefined ||
	window.localStorage.getItem(debugTrigger) === 'true'
) {
	load();
}

hashParams.addListener(debugTrigger, load);

export function load(): void {
	try {
		const baseUrl = _getBaseUrl(),
			script = document.createElement('script');

		script.src = `${baseUrl}/advert-debug.js`;
		script.async = true;
		script.addEventListener('load', () => {
			const interval = setInterval(() => {
				if (window.advert?.debug?.start) {
					window.advert.debug.start();
					clearInterval(interval);
				}
			}, 1000);
		});

		document.head.appendChild(script);
	} catch (e) {
		console.warn('[ADVERT] Could not load debug script', e);
	}
}

function _getBaseUrl(): string {
	if (document.currentScript && document.currentScript instanceof HTMLScriptElement) {
		return document.currentScript.src.slice(0, document.currentScript.src.lastIndexOf('/'));
	}

	return 'https://advertising-cdn.dpgmedia.cloud/web-advertising/snapshot';
}
